import { Badge } from "shared/ui/badge"
import { Users } from "lucide-react"
import type { WorkerSelectionItem } from "modules/permit"

interface WorkersTabProps {
  selectedWorkers: WorkerSelectionItem[]
}

export function WorkersTab({ selectedWorkers }: WorkersTabProps) {
  return (
    <div className="space-y-3 pt-0">
      <section className="rounded-lg border border-dashed border-gray-300 p-4 text-sm">
        <div className="flex items-center gap-2">
          <Users className="h-4 w-4 text-sky-500" />
          <p className="font-semibold text-gray-900">ทีมงาน/ผู้รับเหมา</p>
        </div>
        <p className="mt-1 text-xs text-gray-500">
          {selectedWorkers.length > 0
            ? `มีรายชื่อทั้งหมด ${selectedWorkers.length} คน`
            : "ยังไม่มีการเพิ่มรายชื่อทีมงาน"}
        </p>
      </section>

      {selectedWorkers.length === 0 ? (
        <p className="text-xs text-gray-500">ยังไม่เพิ่มข้อมูลทีมงาน</p>
      ) : (
        selectedWorkers.map((worker, index) => (
          <div
            key={worker.workerId ?? `${worker.fullName ?? "worker"}-${index}`}
            className="rounded-lg border p-3 text-sm"
          >
            <div className="flex items-center justify-between">
              <p className="font-semibold text-gray-900">{worker.fullName || "ไม่ระบุชื่อ"}</p>
              {worker.roleInPermit ? (
                <Badge variant="secondary" className="text-[11px]">
                  {worker.roleInPermit}
                </Badge>
              ) : null}
            </div>
            <p className="text-xs text-gray-500">
              {worker.companyName || "ไม่ระบุบริษัท"}
              {worker.orgName ? ` • ${worker.orgName}` : ""}
              {" • "}
              {worker.jobRole || worker.roleInPermit || "ไม่ระบุหน้าที่"}
            </p>
            {worker.cardNumber ? <p className="text-xs text-gray-500">Card No: {worker.cardNumber}</p> : null}
          </div>
        ))
      )}
    </div>
  )
}
